import { useState, useEffect } from "react";
import api from "../utils/api";

export const useLawyers = (page = 1, perPage = 12) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLawyers = async () => {
      try {
        const response = await api.get(`/lawyers?page=${page}&per_page=${perPage}`);
        if (response.data.success) {
          setData(response.data);
        } else {
          setError("Failed to load lawyers.");
        }
      } catch (err) {
        setError(err.response?.data?.message || "Network error.");
      } finally {
        setLoading(false);
      }
    };

    fetchLawyers();
  }, [page, perPage]);

  return { data, loading, error, refetch: () => setLoading(true) };
};